module.exports = __webpack_public_path__ + "img/helpdetail6.6ccfe222.png";